export const STATUS = {
  ALL: "",
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending"
};

export const statusLabels = () => {
  return {
    [STATUS.ACTIVE]: "Active",
    [STATUS.INACTIVE]: "Deactivated",
    [STATUS.PENDING]: "Pending",
  };
};

export const statusNotificationLabels = () => {
  return {
    [STATUS.ACTIVE]: "Activated",
    [STATUS.INACTIVE]: "Deactivated",
    [STATUS.PENDING]: "Pending",
  };
};

export const statusActions = () => {
  return {
    [STATUS.ACTIVE]: "Activate",
    [STATUS.INACTIVE]: "Deactivate",
    [STATUS.PENDING]: "Pending",
  };
};

export const statusFilters = () => {
  return {
    [STATUS.ALL]: "All",
    [STATUS.ACTIVE]: "Active",
    [STATUS.INACTIVE]: "Deactivated",
  };
};

export const statusBgColors = {
  [STATUS.ACTIVE]: "linear-gradient(to right, #19C38B, #088D96)",
  [STATUS.INACTIVE]: "linear-gradient(to right, #797979, #595959)",
  [STATUS.PENDING]: "linear-gradient(to right, #FFB22C, #FFB22C)",
};
